import {useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronDownIcon, ChevronUpIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useRecentFiltersWithSurvey} from "../hooks/use_recent_filters_with_survey";
import {buildRecentSearchFormValues, buildSearchUrl} from "../utils/build_recent_filters_search_values";
import {getRecentFilterFilterText, getSurveyFilterText} from "../utils/recent_filters_display_utils";

interface IProps {
    className?: string;
}

export const RecentFiltersSearch = (props: IProps) => {
    const {className} = props;

    const {recentFilters, surveyFormValues, shouldShowSurvey} = useRecentFiltersWithSurvey();

    const hasSurvey = shouldShowSurvey && surveyFormValues;
    const totalCount = (hasSurvey ? 1 : 0) + recentFilters.length;
    const [isExpanded, setIsExpanded] = useState(false);
    const visibleCount = isExpanded ? totalCount : Math.min(2, totalCount);
    const showSurvey = hasSurvey && visibleCount >= 1;
    const recentCount = visibleCount - (showSurvey ? 1 : 0);
    const recentFiltersToShow = recentFilters.slice(0, recentCount);
    const showExpandButton = totalCount > 3;

    const withHeader = recentFilters.length > 0 || hasSurvey;

    return (
        <div className={css({mb: withHeader ? 3 : 0})}>
            {withHeader && (
                <Text variant="mini_header" style={{display: "block", marginBottom: "1rem"}}>
                    Twoje ostatnie wyszukiwania
                </Text>
            )}

            {showSurvey && surveyFormValues && (
                <RecentFilterButton
                    url={buildSearchUrl(surveyFormValues)}
                    title={getSurveyFilterText(surveyFormValues)}
                    text="Twoje preferencje"
                    className={className}
                    isLast={recentCount === 0}
                />
            )}

            {recentFiltersToShow.map((recentFilter, index) => (
                <RecentFilterButton
                    key={`${recentFilter.timestamp}-${index}`}
                    url={buildSearchUrl(buildRecentSearchFormValues(recentFilter))}
                    title={getRecentFilterFilterText(recentFilter)}
                    text={`Wyszukiwanie z dnia: ${formatDate(new Date(recentFilter.timestamp).toISOString(), dateTimeFormat.shortDate)}`}
                    className={className}
                    isLast={index === recentFiltersToShow.length - 1}
                />
            ))}

            {showExpandButton && (
                <Button
                    type="button"
                    variant="none_secondary"
                    size="x-small"
                    fullWidth
                    className={expandButtonStyle}
                    onClick={() => setIsExpanded((prev) => !prev)}
                    iconRight={isExpanded ? ChevronUpIcon : ChevronDownIcon}
                >
                    {isExpanded ? "Zwiń twoje wyszukiwania" : "Rozwiń twoje wyszukiwania"}
                </Button>
            )}
        </div>
    );
};

interface IRecentFilterButtonProps {
    url: string;
    title: string;
    text: string;
    className?: string;
    isLast?: boolean;
}

const RecentFilterButton = (props: IRecentFilterButtonProps) => {
    const {url, title, text, className, isLast} = props;

    return (
        <Button href={url} variant="none_secondary" fullWidth className={cx(recentFiltersButtonStyle, isLast && recentFiltersButtonLastStyle, className)}>
            <div className={recentFiltersTextWrapper}>
                <Text variant="body_copy_1" className={transformNone}>
                    {title}
                </Text>

                <Text variant="info_txt_1" color="var(--colors-gray-700)" className={transformNone}>
                    {text}
                </Text>
            </div>
        </Button>
    );
};

const recentFiltersButtonStyle = css({
    height: "auto",
    minHeight: "64px",
    textAlign: "left",
    textWrap: "wrap",
    justifyContent: "flex-start",
    borderBottom: "1px solid var(--colors-gray-200)",
    p: 1,
    gap: 1,
    borderRadius: 0,
    textDecoration: "none",
    color: "inherit",

    "& svg": {
        fill: "var(--colors-secondary)"
    },
    _hover: {
        backgroundColor: "var(--colors-gray-200)"
    },
    _focus: {
        backgroundColor: "var(--colors-gray-200)"
    }
});

const recentFiltersButtonLastStyle = css({
    borderBottom: "none"
});

const expandButtonStyle = css({
    justifyContent: "center",
    mt: 1,
    borderBottom: "none",
    height: "40px"
});

const recentFiltersTextWrapper = css({
    display: "flex",
    flexDirection: "column"
});

const transformNone = css({
    textTransform: "none"
});
import {useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronDownIcon, ChevronUpIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useRecentFiltersWithSurvey} from "../hooks/use_recent_filters_with_survey";
import {buildRecentSearchFormValues, buildSearchUrl} from "../utils/build_recent_filters_search_values";
import {getRecentFilterFilterText, getSurveyFilterText} from "../utils/recent_filters_display_utils";

interface IProps {
    className?: string;
}

export const RecentFiltersSearch = (props: IProps) => {
    const {className} = props;

    const {recentFilters, surveyFormValues, shouldShowSurvey} = useRecentFiltersWithSurvey();

    const hasSurvey = shouldShowSurvey && surveyFormValues;
    const totalCount = (hasSurvey ? 1 : 0) + recentFilters.length;
    const [isExpanded, setIsExpanded] = useState(false);
    const visibleCount = isExpanded ? totalCount : Math.min(2, totalCount);
    const showSurvey = hasSurvey && visibleCount >= 1;
    const recentCount = visibleCount - (showSurvey ? 1 : 0);
    const recentFiltersToShow = recentFilters.slice(0, recentCount);
    const showExpandButton = totalCount > 3;

    const withHeader = recentFilters.length > 0 || hasSurvey;

    return (
        <div className={css({mb: withHeader ? 3 : 0})}>
            {withHeader && (
                <Text variant="mini_header" style={{display: "block", marginBottom: "1rem"}}>
                    Twoje ostatnie wyszukiwania
                </Text>
            )}

            {showSurvey && surveyFormValues && (
                <RecentFilterButton
                    url={buildSearchUrl(surveyFormValues)}
                    title={getSurveyFilterText(surveyFormValues)}
                    text="Twoje preferencje"
                    className={className}
                    isLast={recentCount === 0}
                />
            )}

            {recentFiltersToShow.map((recentFilter, index) => (
                <RecentFilterButton
                    key={`${recentFilter.timestamp}-${index}`}
                    url={buildSearchUrl(buildRecentSearchFormValues(recentFilter))}
                    title={getRecentFilterFilterText(recentFilter)}
                    text={`Wyszukiwanie z dnia: ${formatDate(new Date(recentFilter.timestamp).toISOString(), dateTimeFormat.shortDate)}`}
                    className={className}
                    isLast={index === recentFiltersToShow.length - 1}
                />
            ))}

            {showExpandButton && (
                <Button
                    type="button"
                    variant="none_secondary"
                    size="x-small"
                    fullWidth
                    className={expandButtonStyle}
                    onClick={() => setIsExpanded((prev) => !prev)}
                    iconRight={isExpanded ? ChevronUpIcon : ChevronDownIcon}
                >
                    {isExpanded ? "Zwiń twoje wyszukiwania" : "Rozwiń twoje wyszukiwania"}
                </Button>
            )}
        </div>
    );
};

interface IRecentFilterButtonProps {
    url: string;
    title: string;
    text: string;
    className?: string;
    isLast?: boolean;
}

const RecentFilterButton = (props: IRecentFilterButtonProps) => {
    const {url, title, text, className, isLast} = props;

    return (
        <Button href={url} variant="none_secondary" fullWidth className={cx(recentFiltersButtonStyle, isLast && recentFiltersButtonLastStyle, className)}>
            <div className={recentFiltersTextWrapper}>
                <Text variant="body_copy_1" className={transformNone}>
                    {title}
                </Text>

                <Text variant="info_txt_1" color="var(--colors-gray-700)" className={transformNone}>
                    {text}
                </Text>
            </div>
        </Button>
    );
};

const recentFiltersButtonStyle = css({
    height: "auto",
    minHeight: "64px",
    textAlign: "left",
    textWrap: "wrap",
    justifyContent: "flex-start",
    borderBottom: "1px solid var(--colors-gray-200)",
    p: 1,
    gap: 1,
    borderRadius: 0,
    textDecoration: "none",
    color: "inherit",

    "& svg": {
        fill: "var(--colors-secondary)"
    },
    _hover: {
        backgroundColor: "var(--colors-gray-200)"
    },
    _focus: {
        backgroundColor: "var(--colors-gray-200)"
    }
});

const recentFiltersButtonLastStyle = css({
    borderBottom: "none"
});

const expandButtonStyle = css({
    justifyContent: "center",
    mt: 1,
    borderBottom: "none",
    height: "40px"
});

const recentFiltersTextWrapper = css({
    display: "flex",
    flexDirection: "column"
});

const transformNone = css({
    textTransform: "none"
});
